async function getPDPLocation(pid) {
  try {
    const response = await fetch("https://tools.trollbeads.us/api/v1/shopify/locations/"+pid);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const productData = data.data.data.product;

    return {
        name: productData.title,
        variants: productData.variants.edges.map(variantEdge => {
            const variant = variantEdge.node;
            const locations = variant.inventoryItem.inventoryLevels.edges.map(levelEdge => {
            const node = levelEdge.node;
            return {
                id: node.location.name.includes("Prague") ? "cz" : "hu",
                name: node.location.name,
                quantity: node.quantities[0]?.quantity ?? 0
            };
            });
            return {
            sku: variant.sku,
            id: variant.id,
            locations
            };
        })
        };
  } catch (err) {
    console.error("Fetch error:", err);
    throw err;
  }
}

function getShopDomain() {
  const host = window.location.hostname.toLowerCase();

  // Normalize common cases
  if (host.includes('trollbeads.cz')) return 'trollbeads.cz';
  if (host.includes('trollbeads.sk')) return 'trollbeads.sk';
  if (host.includes('trollbeads.hu')) return 'trollbeads.hu';

  // fallback: return the full hostname
  return host;
}
